import { THEME_COLOR } from "config/profile_constants";
import React from "react";
import styled from "styled-components";

const StyledButton = styled.button`
  padding: 12px 13px;
  padding-bottom: 15px;
  background: ${THEME_COLOR};
  border-radius: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 1rem;
  font-weight: 500;
`;

const Button = ({ clickEvent, children, ...props }) => {
  return <StyledButton {...props}>{children}</StyledButton>;
};

Button.defaultProps = {
  clickEvent: (e) => {
    return;
  },
};

export default Button;
